import React from 'react';

type PortalContainerProps = { isOpen: boolean; children: React.ReactNode; loginRef: any };

const PortalContainer = ({ isOpen, children, loginRef }: PortalContainerProps) => {
	const visible = isOpen ? 'block' : 'none';
	const [pos, setPos] = React.useState({ top: 0, left: 0 });

	React.useEffect(() => {
		if (loginRef.current) {
			const rect = loginRef.current.getBoundingClientRect();
			setPos({ top: rect.top, left: rect.left });
		}
	}, [loginRef]);

	return (
		<div
			className={`vtex-login-2-x-portalContainer portalContainer`}
			style={{ position: 'fixed', top: '0px', left: '0px', zIndex: 2147483647, display: visible }}
		>
			<div className="vtex-login-2-x-portalWrapper portalWrapper">
				<div className="flex justify-start" style={{ position: 'absolute', top: pos.top + 50, left: pos.left - 290 }}>
					<div className="absolute">
						<div>{children}</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default PortalContainer;
